export const GET_APPLICATIONS_LIST = '/building/get_applications_list';
export const SHOW_DATA = '/building/show_data';
export const CREATE_APPLICATION = '/building/create_application';
export const UPDATE_APPLICATION = '/building/update_application';

export const GET_LAND_APPLICATIONS_LIST = '/land/get_land_applications';
export const GET_BUILDING_KINDS_LIST = '/building/get_building_kinds';
export const GET_STRUCTURAL_TYPES_LIST = '/building/get_structural_types';
export const GET_SINGLE_BUILDING_OWNER = '/building/get_single_building_owner';
export const GET_SINGLE_TRANSACT_CODE = '/building/get_single_transaction_code';
export const GET_SINGLE_LAND_APPLICATION = '/land/get_single_land_application';
export const GET_SINGLE_BUILDING_KIND = '/building/get_single_building_kind';
export const GET_SINGLE_STRUCTURAL_TYPE = '/building/get_single_structural_type';

export const GET_LAND_APPRAISAL = '/land/get_land_appraisal';
export const GET_SINGLE_LAND_APPRAISAL = '/land/get_single_land_appraisal';
export const CREATE_LAND_APPRAISAL = '/land/create_land_appraisal';
export const UPDATE_LAND_APPRAISAL = '/land/update_land_appraisal';
export const REMOVE_LAND_APPRAISAL = '/land/remove_land_appraisal';

export const GET_LAND_PROPERTY_ASSESSMENT = '/land/get_land_property_assessment';
export const GET_SINGLE_LAND_PROPERTY_ASSESSMENT = '/land/get_single_land_property_assessment';
export const CREATE_LAND_PROPERTY_ASSESSMENT = '/land/create_land_property_assessment';
export const UPDATE_LAND_PROPERTY_ASSESSMENT = '/land/update_land_property_assessment';
export const REMOVE_LAND_PROPERTY_ASSESSMENT = '/land/remove_land_property_assessment';

export const GET_LAND_MARKET_VALUE = '/land/get_land_market_value';
export const GET_SINGLE_LAND_MARKET_VALUE = '/land/get_single_land_market_value';
export const CREATE_LAND_MARKET_VALUE = '/land/create_land_market_value';
export const UPDATE_LAND_MARKET_VALUE = '/land/update_land_market_value';
export const REMOVE_LAND_MARKET_VALUE = '/land/remove_land_market_value';

export const GET_LAND_CLASSIFICATIONS = '/land/get_land_classifications';
export const GET_SINGLE_LAND_CLASS = '/land/get_single_land_class';

export const GET_TRANSACTION_CODES = '/get_transaction_codes';

export const GET_OWNER_LIST = '/get_owner_list';
export const GET_SINGLE_LAND_OWNER = '/get_single_land_owner';

export const GET_PROVINCE = 'NEW_BUSINESSES/get_provinces';
export const GET_MUNICIPALITIES = 'NEW_BUSINESSES/get_municipalities';
export const GET_BARANGAYS = 'NEW_BUSINESSES/get_barangays';
export const FIND_TDN = 'building/find_td';
export const GET_BUILDING_MATERIAL_TYPE = 'building/get_building_material_type';
export const GET_SINGLE_BUILDING_MATERIAL_TYPE = 'building/get_single_building_material_type';
export const GET_SINGLE_BUILDING_MATERIAL = 'building/get_single_building_material_type';
export const GET_BUILDING_COMPONENTS = 'building/get_building_components';
export const GET_ACTUAL_USE_LIST = 'building/get_actual_use_list';
export const GET_SINGLE_BUILDING_COMPONENT = 'building/get_single_building_component';
export const SHOW_STRUCTURAL_TYPE = 'building/show_structural_type';
export const GET_DISTRICTS_LIST = 'building/get_districts_list';
export const GET_APPOINTED_PERSONS = 'building/get_appointed_persons';
export const CANCEL_APPLICATION = 'building/cancel_application';
export const POST_APPLICATION = 'building/post_application';
export const GET_PAID_TRANSACTION = 'building/paid_transactions';
export const GET_PAYMENT_HISTORY = 'building/payment_history';
export const REVERT_APPLICATION = 'building/revert_application';
export const GET_TAX_EFFECTIVITY_PERIOD = '/get_tax_effectivity_periods';
export const GET_LOCATION_LIST = '/get_location_list';
export const SEARCH_TDN_CONSOLIDATION = '/building/search_tdn_consolidation';
export const SEARCH_TDN_SUBDIVISION = '/building/search_tdn_subdivision';
export const UPDATE_BUILDING_APPLICATION = 'building/update_building_application';
export const GET_EFFECTIVITY_PERIOD = 'building/get_effectivity_period';

export const FAAS_HISTORY_URL =
  '/api/v1/rpt/administrator/buildings/building_applications/{id}/building_history_logs/{historyId}/faas';

export const FAAS_URL =
  'api/v1/rpt/administrator/buildings/building_applications/{id}/faas';

export const TAX_DECLARATION_URL =
  'api/v1/rpt/administrator/buildings/building_applications/{id}/tax_declaration';

export const TAX_DECLARATION_HISTORY_URL =
  'api/v1/rpt/administrator/buildings/building_applications/{id}/building_history_logs/{historyId}/tax_declaration';

export const GET_LOGS = 'building/get_logs';
export const SEARCH_TDN = 'building/search_tdn';
export const CREATE_TRANSFER_APPLICATION = 'building/create_transfer_application';
export const UPDATE_TRANSFER_APPLICATION = 'building/update_transfer_application';
export const GET_TDN = 'building/get_tdn';
export const SEARCH_PIN = 'building/search_pin';

export const FORM_DATA = {
  td_owner: '',
  td_oct: '',
  td_oct_date: '',
  td_survey_no: '',
  td_lot_no: '',
  td_block: '',
  td_area: '',
  property_province_id: '',
  property_district_id: '',
  property_barangay_id: '',
  property_street: '',
  rptax_land_application_id: '',
  land_application_id: '',
  rptax_owner_id: '',
  rptax_transaction_code_id: '',
  tdn: '',
  arp_no: '',
  pin: '',
  administrator_beneficial_user_id: '',
  property_boundaries_land_sketch_photo_url: '',
  rptax_building_kind_id: '',
  rptax_building_structural_type_id: '',
  building_permit_no: '',
  date_issued: '',
  condominium_certificate_title: '',
  certificate_completion_issued_on: '',
  certificate_occupancy_issued_on: '',
  date_constructed_completed: '',
  date_occupied: '',
  building_age: '',
  floor_plan_photo_url: '',
  effectivity_of_assessment_reassessment_qtr: '',
  effectivity_of_assessment_reassessment_yr: '',
  appraised_assessed_by_id: '',
  appraised_assessed_at: '',
  recommending_by_id: '',
  recommending_at: '',
  approved_by_id: '',
  approved_at: '',
  registered: '',
  memoranda: '',
  no_of_storeys: 0,
  floor_storey_areas: [],
  total_floor_area: 0,
  structural_materials: [],
  additional_items: [],
  for_improvement: 0,
  rptax_building_application_id: '',
  condominium_certificate_title_date: '',
};

export const LAND_APPRAISAL_FORM_DATA = {
  rptax_land_classification_id: '',
  rptax_land_sub_classification_id: '',
  area: '',
  classification: '',
  sub_classification: '',
};

export const LAND_PROPERTY_ASSESSMENT_FORM_DATA = {
  actual_use: '',
};

export const LAND_MARKET_VALUE_FORM_DATA = {
  adjustment_factor: '',
  percentage_adjustment: '',
}